// extracted by mini-css-extract-plugin
module.exports = {"receipt-loyalty-info":"_3KkfUVAM75mGbyy9txJKbg","title":"_3VEh4fCfHKnJyQ_hM6LNFZ","loyalty-info-detail":"_1sR16QlfBKbI9zoYEcz25"};